import { render, staticRenderFns } from "./ManageSkillConfig.vue?vue&type=template&id=38970a1d&"
import script from "./ManageSkillConfig.vue?vue&type=script&lang=js&"
export * from "./ManageSkillConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports